module.exports = __webpack_public_path__ + "static/media/vip-member@3x.173fdfef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/vip-member@3x.png
// module id = 2033
// module chunks = 6